import { PermissionsEnum } from './Permissions';

const {
  CAN_READ_BUILDING_LOAN_APPLICATIONS,
  CAN_READ_COMMERCIAL_LOAN_APPLICATIONS,
  CAN_READ_DOES_NOT_HAVE_HOME_LOAN_APPLICATIONS,
  CAN_READ_HOME_LOAN_APPLICATIONS,
  CAN_READ_MORTGAGE_APPLICATIONS,
  CAN_READ_NOT_CLASSIFIED_APPLICATIONS,
  CAN_READ_PERSONAL_LOAN_APPLICATIONS,
  CAN_READ_PYMES_SOLUTION_LOAN_APPLICATIONS,
  CAN_READ_SOLUTION_LOAN_APPLICATIONS,
  CAN_READ_VEHICLE_LOAN_APPLICATIONS,
  CAN_READ_P2P_LOAN_APPLICATIONS,
  CAN_READ_INCREASING_QUOTA_SOLUTION_LOAN_APPLICATIONS,
} = PermissionsEnum;

const LoanApplicationTypes = {
  COMMERCIAL: {
    value: 'commercial',
    text: 'Comercial',
    permission: CAN_READ_COMMERCIAL_LOAN_APPLICATIONS,
  },
  BUILDING: {
    value: 'building',
    text: 'Construcción',
    permission: CAN_READ_BUILDING_LOAN_APPLICATIONS,
  },
  HOME: {
    value: 'home',
    text: 'Hogar',
    permission: CAN_READ_HOME_LOAN_APPLICATIONS,
  },
  MORTGAGE: {
    value: 'mortgage',
    text: 'Mejora tu Hipoteca',
    permission: CAN_READ_MORTGAGE_APPLICATIONS,
  },
  PERSONAL: {
    value: 'personal',
    text: 'Personal',
    permission: CAN_READ_PERSONAL_LOAN_APPLICATIONS,
  },
  SOLUTION: {
    value: 'solution',
    text: 'Solución',
    permission: CAN_READ_SOLUTION_LOAN_APPLICATIONS,
  },
  INCREASING_QUOTA_SOLUTION: {
    value: 'increasing_quota_solution',
    text: 'Solución Cuota Creciente',
    permission: CAN_READ_INCREASING_QUOTA_SOLUTION_LOAN_APPLICATIONS,
  },
  PYMES_SOLUTION: {
    value: 'pymes_solution',
    text: 'Solución Empresa',
    permission: CAN_READ_PYMES_SOLUTION_LOAN_APPLICATIONS,
  },
  DOES_NOT_HAVE_HOME: {
    value: 'does_not_have_home',
    text: 'No tiene vivienda',
    permission: CAN_READ_DOES_NOT_HAVE_HOME_LOAN_APPLICATIONS,
  },
  NOT_CLASSIFIED: {
    value: 'no_clasificado',
    text: 'No clasificado',
    permission: CAN_READ_NOT_CLASSIFIED_APPLICATIONS,
  },
  VEHICLE: {
    value: 'vehicle',
    text: 'Vehicular',
    permission: CAN_READ_VEHICLE_LOAN_APPLICATIONS,
  },
  P2P: {
    value: 'p2p',
    text: 'P2P',
    permission: CAN_READ_P2P_LOAN_APPLICATIONS,
  },
};
const LoanApplicationKeys = Object.keys(LoanApplicationTypes);

export const requestTypeOptions = LoanApplicationKeys.map(
  p => LoanApplicationTypes[p]
);

export const LoanApplicationTextFromValue = LoanApplicationKeys.reduce(
  (prev, current) => {
    const loanApplicationType = LoanApplicationTypes[current];
    return { ...prev, [loanApplicationType.value]: loanApplicationType.text };
  },
  {}
);

export default LoanApplicationTypes;



// WEBPACK FOOTER //
// ./src/utils/constants/RequestType.js